<div class="details">
  <mat-list *ngIf="moreDetails()">
    <mat-list-item *ngIf="data?.name?.length > 1">
      <span mat-line matListItemTitle>Names</span>
      <span mat-line matListItemLine *ngFor="let name of data.name"
        >{{ name?.firstName }} {{ name?.lastName }}</span
      >
    </mat-list-item>

    <mat-list-item *ngIf="data?.address?.length > 1">
      <span mat-line matListItemTitle>Addresses</span>
      <span mat-line matListItemLine *ngFor="let address of data.address">{{ address }}</span>
    </mat-list-item>

    <mat-list-item *ngIf="data?.email?.length > 1">
      <span mat-line matListItemTitle>Emails</span>
      <span mat-line matListItemLine *ngFor="let email of data.email">{{ email }}</span>
    </mat-list-item>

    <mat-list-item *ngIf="data?.relatives?.length > 1">
      <span mat-line matListItemTitle>Relatives</span>
      <span mat-line matListItemLine *ngFor="let relative of data.relatives"
        >{{ relative?.firstName }} {{ relative?.lastName }}</span
      >
    </mat-list-item>
  </mat-list>
  <div class="no-details-div" *ngIf="!moreDetails()">
    <h1 class="no-details">No Additional Details</h1>
  </div>
</div>
